import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AssetVehicleLinkComponent } from '../asset-vehicle-entry/asset-vehicle-link/asset-vehicle-link.component';
import { AssetVehicleApprovalLandingComponent } from './asset-vehicle-approval-landing/asset-vehicle-approval-landing.component';

const routes: Routes = [
  {
    path: '', component: AssetVehicleLinkComponent,
    children: [
      { path: 'vehicleQRApproval', component: AssetVehicleApprovalLandingComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssetVehicleApprovalRoutingModule { }
